import { useRouter } from 'next/router';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// Hooks
import { useWebiny } from '@/providers/WebinyProvider';
// Styles & Assets
import { colors } from '@/theme';

export default function NodeBanner({ handleCloseBanner }) {
  const router = useRouter();
  const { nodeSetupCard } = useWebiny();

  const handleClick = (item) => () =>
    item.title.includes('fabric')
      ? window.open(item.url, '_blank')
      : router.push(item.url);

  return (
    <Paper
      elevation={1}
      sx={{
        width: '100%',
        backgroundImage: `url(${nodeSetupCard.image})`,
        marginBottom: '24px',
        padding: '24px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <IconButton
        onClick={handleCloseBanner}
        size="small"
        sx={{
          position: 'absolute',
          right: 6,
          top: 6,
        }}
        data-core-qa="closeModal"
      >
        <CloseIcon sx={{ fill: colors.common.white }} fontSize="small" />
      </IconButton>
      <Box
        sx={{
          width: '70%',
          '@media (max-width: 820px)': {
            width: '100%',
          },
        }}
      >
        <Typography variant="body1">{nodeSetupCard.description}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '24px',
          marginTop: '24px',
          '@media (max-width: 820px)': {
            justifyContent: 'center',
          },
        }}
      >
        {nodeSetupCard.platforms.map((item) => (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            key={item.title}
          >
            <Box
              sx={{
                width: '25px',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                background: `url(${item.icon}) no-repeat center center / contain`,
                ':hover': {
                  transform: 'scale(1.3)',
                },
              }}
              onClick={handleClick(item)}
            ></Box>
            <Typography variant="body2">{item.title}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
